import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import type { FCC } from '../../utils/types';

const OnRouteChange: FCC = ({ children }) => {
  const location = useLocation();

  /* Set scroll position to top when navigating
  We need to do this for the App element, as html and body is 100%,
  and our App element handles scrolling the content instead. 
  */

  // biome-ignore lint/correctness/useExhaustiveDependencies: we need to trigger on path change to make it work
  useEffect(() => {
    const app = document.getElementById('app');
    if (app === null) {
      return;
    }
    try {
      app.scrollTo(0, 0);
    } catch {
      app.scrollTop = 0;
    }
  }, [location.pathname]);

  return <>{children}</>;
};

export default OnRouteChange;
